import { render, staticRenderFns } from "./MedicationEditDialog.vue?vue&type=template&id=3daa5bf4"
import script from "./MedicationEditDialog.vue?vue&type=script&lang=js"
export * from "./MedicationEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports